import ChatPage from "pages/Chat/ChatPage";
import Bills from "pages/CommonPage/Main/Bill/Bills";
import PaymentResult from "pages/CommonPage/Main/PaymentResult/PaymentResult";
import BookingCalendar from "pages/LandlordPage/BookingCalendar/BookingCalendar";
import Buildings from "pages/LandlordPage/Buildings/Buildings";
import ContractsTab from "pages/LandlordPage/Contracts/ContractsTab";
import PaymentsByRoom from "pages/LandlordPage/PaymentsByRoom/PaymentsByRoom";
import { Route, Routes } from "react-router-dom";
import AdminProtectedRoute from "../components/AdminProtectedRoute/AdminProtectedRoute";
import LandlordProtectedRoute from "../components/LandlordProtectedRoute/LandlordProtectedRoute";
import ProtectedRedirect from "../components/ProtectedRedirect/ProtectedRedirect";
import RenterProtectedRoute from "../components/RenterProtectedRoute/RenterProtectedRoute";
import AdminPage from "../pages/AdminPage/AdminPage";
import CreateBuilding from "../pages/AuthPage/CreateBuilding/CreateBuilding";
import Forgot from "../pages/AuthPage/Forgot/Forgot";
import Login from "../pages/AuthPage/Login/Login";
import Register from "../pages/AuthPage/Register/Register";
import Start from "../pages/AuthPage/Start/Start";
import Verify from "../pages/AuthPage/Verify/Verify";
import LandingPage from "../pages/CommonPage/Landing/LandingPage";
import ContractPage from "../pages/CommonPage/Main/Contract/Contract";
import Find from "../pages/CommonPage/Main/FindRoom/FindRoom";
import Home from "../pages/CommonPage/Main/Home/Home";
import Main from "../pages/CommonPage/Main/Main";
import RoomListWithReviews from "../pages/CommonPage/Main/RoomListWithReviews/RoomListWithReviews";
import RoomDetail from "../pages/CommonPage/Main/RoomDetail/Detail";
import Saved from "../pages/CommonPage/Main/Saved/SavedRoom";
import ViewingAppointments from "../pages/CommonPage/Main/ViewingAppointments/ViewingAppointments";
import Profile from "../pages/CommonPage/Profile/Profile";
import Dashboard from "../pages/LandlordPage/Dashboard/Dashboard";
import LandlordPage from "../pages/LandlordPage/LandlordPage";
import ManageRoom from "../pages/LandlordPage/ManageRoom/ManageRoom";
import ManageTenants from "../pages/LandlordPage/ManageTenants/ManageTenants";
import Settings from "../pages/LandlordPage/Settings/Settings";
import Subscription from "../pages/LandlordPage/Subscription/Subscription";
import Support from "../pages/LandlordPage/Support/Support";
import Transaction from "../pages/LandlordPage/Transaction/Transaction";
const AppRoutes = () => {
  return (
    <Routes>
      {/* Common Routes */}
      <Route path="/" element={<ProtectedRedirect />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route
        path="/main"
        element={
          <RenterProtectedRoute>
            <Main />
          </RenterProtectedRoute>
        }
      >
        <Route path="home" element={<Home />} />
        <Route path="room-detail/:id" element={<RoomDetail />} />
        <Route path="find" element={<Find />} />
        <Route path="saved" element={<Saved />} />
        <Route path="viewing-appointments" element={<ViewingAppointments />} />
        <Route path="contract" element={<ContractPage />} />
        <Route path="rooms-with-reviews" element={<RoomListWithReviews />} />
        <Route path="payment-result" element={<PaymentResult />} />
        <Route path="bills" element={<Bills />} />
        <Route index element={<Home />} />
      </Route>

      {/* Auth Routes */}
      <Route path="/start" element={<Start />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/verify" element={<Verify />} />
      <Route
        path="/create-building"
        element={
          <LandlordProtectedRoute>
            <CreateBuilding />
          </LandlordProtectedRoute>
        }
      />

      {/* Landlord Routes */}
      <Route
        path="/landlord"
        element={
          <LandlordProtectedRoute>
            <LandlordPage />
          </LandlordProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="manage-room" element={<ManageRoom />} />
        <Route path="manage-tenants" element={<ManageTenants />} />
        <Route path="transaction" element={<Transaction />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="settings" element={<Settings />} />
        <Route path="support" element={<Support />} />
        <Route path="contracts" element={<ContractsTab />} />
        <Route path="payments-by-room" element={<PaymentsByRoom />} />
        <Route path="booking-calendar" element={<BookingCalendar />} />
        <Route path="buildings" element={<Buildings />} />
        <Route path="chat" element={<ChatPage />} />
      </Route>

      {/* Admin Routes */}
      <Route
        path="/admin/*"
        element={
          <AdminProtectedRoute>
            <AdminPage />
          </AdminProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
